<template>
    <j-modal
      :title="$t('选择新表')"
      :width="1200"
      :visible="visible"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      :okText="$t('确定')"
      :cancelText="$t('关闭')"
    >
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表类型')">
                <a-select v-model="queryParam.mtCode" :placeholder="$t('请选择表类型')">
                  <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                    {{data.mtName}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        ref="table"
        size="middle"
        :bordered="false"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{ x: 'max-content' }"
        :rowSelection="{ 
          type: 'radio', 
          selectedRowKeys: selectedRowKeys, 
          onChange: onSelectChange 
        }"
        :customRow="customRow"
        @change="handleTableChange"
      >
      </a-table>
    </j-modal>
  </template>
  
  <script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin';
  import JInput from '@/components/jeecg/JInput'
  import DetailList from '@/components/tools/DetailList'
  import { getAction } from '@/api/manage'
  
  const DetailListItem = DetailList.Item
  
  export default {
    mixins: [JeecgListMixin],
    name: 'SelectNewMeterModal',
    components: {
      DetailList,
      DetailListItem,
      JInput
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        queryParam: {
          meterId: '',
          mtCode: undefined,
          mtState: 0
        },
        userTypeList: [], // 表类型数据
        selectedRowKeys: [],
        selectedRows: [],
        url: {
          list: "/jeecg-charge/meter/meterinfo/list",
          userTypeList: "/jeecg-charge/meter/meterType/list",  //表类型请求地址
        },
      }
    },
    computed: {
      columns() {
        return [
          { title: this.$t('表编号'), dataIndex: 'meterId', key: 'meterId' },
          { title: this.$t('表类型'), dataIndex: 'mtName', key: 'mtName' },
          // 添加更多列...
        ]
      },
    },
    methods: {
      // 行选择变化
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      // 自定义行属性
      customRow(record) {
        return {
          props: {
            'data-row-key': record.id // 确保这里使用正确的rowKey
          },
          on: {
            click: () => {
              this.selectedRowKeys = [record.id]
              this.selectedRows = [record]
            }
          }
        }
      },
      // 确定
      handleOk() {
        if (this.selectedRows.length === 0) {
          this.$message.warning(this.$t('请选择一条记录'))
          return
        }
        this.$emit('ok', this.selectedRows[0])
        this.handleCancel()
      },
      // 取消
      handleCancel() {
        this.$emit('update:visible', false)
        this.selectedRowKeys = []
        this.selectedRows = []
      },
      // 查询表类型列表
      queryUserTypeList() {
        let params = {
          pageNo: 1,
          pageSize: 999,
        }
        getAction(this.url.userTypeList, params).then((res) => {
          if (res.success) {
            this.userTypeList = res.result.records || []
          } else {
            this.$message.warning(res.message || this.$t('获取表类型失败'))
          }
        }).catch(() => {
          this.$message.error(this.$t('获取表类型失败'))
        })
      },
      // 初始化
      init() {
        this.queryUserTypeList()
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.queryUserTypeList()
          this.loadData() // 加载表格数据
        }
      }
    },
    created() {
      this.init()
    }
  }
  </script>